import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { LoggerService } from '@libraries/logger';
import { isMobile } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { takeWhile, withLatestFrom } from 'rxjs/operators';

@Directive({
  selector: '[scrollToErrors]',
  standalone: false,
})
export class ScrollToErrorsDirective implements AfterViewInit, OnDestroy {
  @Input('scrollToErrors') form!: NgForm | FormGroupDirective;
  private alive = true;

  constructor(
    private el: ElementRef,
    private scrollService: ScrollToService,
    private store: Store,
    private logger: LoggerService
  ) {}

  ngAfterViewInit() {
    this.form.ngSubmit
      .pipe(
        withLatestFrom(this.store.pipe(select(isMobile))),
        takeWhile(() => this.alive)
      )
      .subscribe(([_, mobile]) => {
        setTimeout(() => {
          try {
            // get all children of the form
            const sections: HTMLElement[] = Array.from(this.el.nativeElement.children);

            let targetElement = this.el.nativeElement.querySelector(
              '.ng-invalid[formControlName], .ng-invalid[formControl], .ng-invalid[ngModel]'
            ) as HTMLElement;

            if (targetElement) {
              const wrapper = targetElement.closest('mat-form-field') as HTMLElement;
              if (wrapper) {
                targetElement = wrapper;
              }
            } else {
              targetElement = sections.find((section) =>
                section.classList.contains('ng-invalid')
              ) as HTMLElement;
            }

            // exit if no errors found
            if (!targetElement) return;

            // generate random error ID and set it if not present
            if (!targetElement.id) {
              targetElement.id = `error-${Math.round(Math.random() * 10000000)}`;
            }

            // finally scroll to the target
            this.scrollService.scrollTo({
              target: targetElement.id,
              offset: this.getScrollOffset(mobile, targetElement),
            });
          } catch (e) {
            this.logger.error(e);
          }
        });
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  getScrollOffset(mobile: boolean, target: HTMLElement): number {
    const headerHeightOffset = mobile ? -155 : -195;
    const paddingOffset = -16;

    return headerHeightOffset + paddingOffset;
  }
}
